import { get, post } from '@/plugins/http'

export default {
  getUserInfo: get('/live/api/v1/user/info'),
  getMyPower: get('/live/api/v1/power/my'), // 获取当前用户的法力，法豆相关信息
  getPowerDelta: get('/live/api/v1/power/delta'), // 开始直播/直播结束获取增量
  signUpPower: post('/live/api/v1/power/signup'), // 报名课程添加法力值
  getServiceCenterAuthority: get('/live/api/v1/user/getServiceCenterAuthority'), // 报名课程添加法力值
  // 修改用户信息
  updateUser: post('/live/api/v1/user/userInfo'),
  // 检测用户是否需要完善个人信息
  checkUserNeedModifyInfo: get('/live/api/v1/user/checkUserNeedModifyInfo'),
  // 法律服务中台通知
  systemNotice: get('live/api/v1/systemNotice/knowledge/detail'),
}
